import React from 'react';
import { Users, TrendingUp, Calendar, Award } from 'lucide-react';

const EstatisticasGerais = ({ totalVotos, dataEncerramento, vencedor, locais }) => {
  const formatarData = (data) => {
    return new Date(data).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Calcula diferença do vencedor para o segundo colocado
  const calcularDiferenca = () => {
    if (!locais || locais.length < 2) return '-';
    const ordenados = [...locais].sort((a, b) => b.votos - a.votos);
    const diferenca = ordenados[0].votos - ordenados[1].votos;
    return `+${diferenca.toLocaleString('pt-BR')}`;
  };

  const estatisticas = [
    {
      icon: Users,
      label: 'Total de Votos',
      valor: totalVotos.toLocaleString('pt-BR'),
      cor: 'text-blue-600',
      bg: 'bg-blue-50'
    },
    {
      icon: TrendingUp,
      label: 'Participação',
      valor: '100%',
      cor: 'text-green-600',
      bg: 'bg-green-50'
    },
    {
      icon: Calendar,
      label: 'Encerramento',
      valor: formatarData(dataEncerramento),
      cor: 'text-purple-600',
      bg: 'bg-purple-50'
    },
    {
      icon: Award,
      label: 'Diferença do 1º',
      valor: calcularDiferenca(),
      cor: 'text-yellow-600',
      bg: 'bg-yellow-50'
    }
  ];

  return (
    <div className="mb-8">
      <h3 className="text-2xl font-bold text-gray-900 text-center mb-6">
        📈 Estatísticas Gerais
      </h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {estatisticas.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow duration-300"
            >
              <div className={`${stat.bg} w-12 h-12 rounded-full flex items-center justify-center mb-4`}>
                <Icon className={`w-6 h-6 ${stat.cor}`} />
              </div>
              <p className="text-sm text-gray-600 mb-1">{stat.label}</p>
              <p className="text-2xl font-bold text-gray-900 break-words">{stat.valor}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EstatisticasGerais;
